import { Ref } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import DriftBotUtil from '../../../../util/DriftBotUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

const showDriftBotVals = {
  business: 'I’d like to speak to someone about Onshape Business Plans',
  purchasing: 'I’d like to speak to someone about purchasing Onshape',
};

export default class ContactSalesProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public onSuccess({
    formDefinition,
    redirectUrl,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
    redirectUrl: string | null;
  }): void {
    super.onSuccess({ formDefinition, redirectUrl });

    const howCanWeHelpYouField = ExternalUtil.findDisplayFieldOrNull({ formDefinition, fieldName: FieldHtmlNameUtil.howCanWeHelpYou });

    const showDriftBot = howCanWeHelpYouField
    && (howCanWeHelpYouField.val === showDriftBotVals.business
      || howCanWeHelpYouField.val === showDriftBotVals.purchasing);

    if (showDriftBot) {
      DriftBotUtil.showDriftBotOrThrow({
        playbook: 'ContactSales',
        formDefinition,
        redirectUrl: redirectUrl || undefined,
      });
    }
  }
}
